let dataDisplay = {
	1: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	2: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	3: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	4: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	5: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	6: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	7: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'blue',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	8: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'blue',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	9: {
		lineWidth: 1,
		originalMin: -62.5,
		originalMax: 62.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	10: {
		lineWidth: 1,
		originalMin: -1,
		originalMax: 1,
		maxZoom: 5,
		minZoom: -5,
		color: 'red',
		zoomable: true,
		upper: true,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	11: {
		lineWidth: 1,
		originalMin: -0.5,
		originalMax: 0.5,
		maxZoom: 5,
		minZoom: -5,
		color: 'hotpink',
		zoomable: true,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	},
	12: {
		lineWidth: 1,
		originalMin: -0.96,
		originalMax: 0.96,
		maxZoom: 5,
		minZoom: -5,
		color: 'green',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	13: {
		lineWidth: 1,
		originalMin: -416.665,
		originalMax: 416.665,
		maxZoom: 5,
		minZoom: -5,
		color: 'black',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	14: {
		lineWidth: 1,
		originalMin: -104.165,
		originalMax: 104.165,
		maxZoom: 5,
		minZoom: -5,
		color: 'green',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	15: {
		lineWidth: 1,
		originalMin: -104.165,
		originalMax: 104.165,
		maxZoom: 5,
		minZoom: -5,
		color: 'green',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	16: {
		lineWidth: 1,
		originalMin: 50,
		originalMax: 100,
		maxZoom: 0,
		minZoom: -10,
		color: 'black',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: true,
		showLocalExtreme: true
	},
	17: {
		lineWidth: 1,
		originalMin: -100,
		originalMax: 100,
		maxZoom: 5,
		minZoom: -5,
		color: 'maroon',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	18: {
		lineWidth: 1,
		originalMin: -100,
		originalMax: 100,
		maxZoom: 5,
		minZoom: -5,
		color: 'maroon',
		zoomable: true,
		upper: false,
		draggable: true,
		showDesat: false,
		showLocalExtreme: false
	},
	19: {
		lineWidth: 1,
		originalMin: 0,
		originalMax: 300,
		color: 'black',
		zoomable: false,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: true
	},
	20: {
		lineWidth: 1,
		originalMin: -2.5,
		originalMax: 2.5,
		color: 'maroon',
		zoomable: false,
		upper: false,
		draggable: false,
		showDesat: false,
		showLocalExtreme: false
	}
}

export default dataDisplay